<template>
  <g
    id="Front_Wheel-4"
    v-on:click="changeSeverity('frontWheel')"
    :class="severityClass"
  >
    <g>
      <path
        class="cls-869"
        d="M642.18,256.92h11.33c1.83,0,3.32,1.49,3.32,3.32v3.24h-17.97v-3.24c0-1.83,1.49-3.32,3.32-3.32Z"
      />
      <rect class="cls-420" x="638.67" y="263.48" width="18.16" height="3.01" />
      <rect
        class="cls-873"
        x="638.39"
        y="263.19"
        width="18.7"
        height=".91"
        rx=".14"
        ry=".14"
      />
      <rect
        class="cls-875"
        x="646.26"
        y="258.76"
        width="2.97"
        height="1.82"
        rx=".91"
        ry=".91"
      />
      <path
        class="cls-872"
        d="M645.9,259.44h3.69c2.07,0,3.75,1.68,3.75,3.75h-11.19c0-2.07,1.68-3.75,3.75-3.75Z"
      />
    </g>
    <path
      class="cls-201"
      d="M658.92,269.72v58.8c0,4.18-3.39,7.57-7.57,7.57h-7.22c-4.18,0-7.57-3.39-7.57-7.57v-58.8c0-4.17,3.39-7.56,7.57-7.56h7.22c4.18,0,7.57,3.39,7.57,7.56Z"
    />
    <rect
      class="cls-611"
      x="611.59"
      y="288.88"
      width="72.32"
      height="20.49"
      rx="10.24"
      ry="10.24"
      transform="translate(946.87 -348.62) rotate(90)"
    />
    <rect class="cls-526" x="637.81" y="271.15" width="1.7" height="42.28" />
    <path
      class="cls-526"
      d="M638.66,324.34h0c.47,0,.85-.38,.85-.85v-10.39c0-.47-.38-.85-.85-.85h0c-.47,0-.85,.38-.85,.85v10.39c0,.47,.38,.85,.85,.85Z"
    />
    <rect class="cls-526" x="655.97" y="271.15" width="1.7" height="42.28" />
    <path
      class="cls-526"
      d="M656.82,324.34h0c-.47,0-.85-.38-.85-.85v-10.39c0-.47,.38-.85,.85-.85h0c.47,0,.85,.38,.85,.85v10.39c0,.47-.38,.85-.85,.85Z"
    />
    <rect class="cls-876" x="630.98" y="310.3" width="32.55" height="4.29" />
    <g>
      <g>
        <polygon
          class="cls-753"
          points="659.75 247.46 665.82 244.65 665.83 240.06 665.82 239.35 665.83 235.82 665.22 235.82 659.76 235.82 659.76 239.34 659.75 240.05 659.75 247.46"
        />
        <path
          class="cls-375"
          d="M658.94,217.21s0-.06,.01-.09c0-.03-.01-.05-.01-.08,0-.64,1.72-1.24,3.86-1.24s3.88,.52,3.88,1.16c0,.02,0,.04-.01,.06,.02,.06,.03,.13,.03,.19l-.03,21.84c0,.16-.19,.29-.42,.29h-.42s-.62,0-.62,0h-5.45s-.42,0-.42,0c-.23,0-.42-.13-.42-.29l.03-21.84Z"
        />
        <path
          class="cls-267"
          d="M658.92,239.05c0-.64,1.73-1.15,3.87-1.15s3.87,.52,3.87,1.15-1.73,1.15-3.87,1.15-3.87-.52-3.87-1.15Z"
        />
        <path
          class="cls-868"
          d="M662.74,238.28c1.13,0,2.14,.15,2.84,.38,.13,.04,.22,.17,.22,.31v30h-6.03v-30.01c0-.14,.08-.26,.21-.31,.69-.24,1.65-.37,2.76-.37Z"
        />
        <path
          class="cls-375"
          d="M658.9,279.37v.39s0,1.31,0,1.31c0,.3,.26,.53,.58,.53h5.71s.59,0,.59,0h.3c.32,0,.58-.23,.57-.52v-12.86s.01-27.86,.01-27.86c0-.01,0-.03,0-.04,0-.01,0-.03,0-.04,0-.64-1.73-1.15-3.87-1.15s-3.88,.52-3.88,1.15c0,.01,0,.02,0,.03,0,.01,0,.03,0,.04v27.86s-.02,6.77-.02,6.77v1.96s0,2.42,0,2.42Z"
        />
        <path
          class="cls-267"
          d="M658.89,281.28c0-.64,1.73-1.15,3.87-1.15s3.87,.52,3.87,1.15-1.73,1.15-3.87,1.15-3.87-.52-3.87-1.15Z"
        />
        <path
          class="cls-889"
          d="M662.75,280.72c1.13,0,2.14,.15,2.84,.38,.13,.04,.22,.17,.22,.31v1.17s0,24.7,0,24.7c0,1.11-.14,2.21-.41,3.28l-.66,2.63h-3.89l-.66-2.63c-.27-1.07-.41-2.17-.41-3.28v-25.87c0-.14,.08-.26,.21-.31,.69-.24,1.65-.37,2.76-.37Z"
        />
      </g>
      <rect
        class="cls-877"
        x="660.39"
        y="309.79"
        width="4.83"
        height="5.42"
        rx="1.23"
        ry="1.23"
        transform="translate(1325.6 625.01) rotate(180)"
      />
    </g>
    <g>
      <g>
        <polygon
          class="cls-750"
          points="629.65 247.46 635.72 244.65 635.73 240.06 635.73 239.35 635.73 235.82 635.12 235.82 629.66 235.82 629.66 239.34 629.66 240.05 629.65 247.46"
        />
        <path
          class="cls-375"
          d="M628.85,217.21s0-.06,.01-.09c0-.03-.01-.05-.01-.08,0-.64,1.72-1.24,3.86-1.24s3.88,.52,3.88,1.16c0,.02,0,.04-.01,.06,.02,.06,.03,.13,.03,.19l-.03,21.84c0,.16-.19,.29-.42,.29h-.42s-.62,0-.62,0h-5.45s-.42,0-.42,0c-.23,0-.42-.13-.42-.29l.03-21.84Z"
        />
        <path
          class="cls-267"
          d="M628.82,239.05c0-.64,1.73-1.15,3.87-1.15s3.87,.52,3.87,1.15-1.73,1.15-3.87,1.15-3.87-.52-3.87-1.15Z"
        />
        <path
          class="cls-887"
          d="M632.65,238.28c1.13,0,2.14,.15,2.84,.38,.13,.04,.22,.17,.22,.31v30h-6.03v-30.01c0-.14,.08-.26,.21-.31,.69-.24,1.65-.37,2.76-.37Z"
        />
        <path
          class="cls-375"
          d="M628.8,279.37v.39s0,1.31,0,1.31c0,.3,.26,.53,.58,.53h5.71s.59,0,.59,0h.3c.32,0,.58-.23,.57-.52v-12.86s.01-27.86,.01-27.86c0-.01,0-.03,0-.04,0-.01,0-.03,0-.04,0-.64-1.73-1.15-3.87-1.15s-3.88,.52-3.88,1.15c0,.01,0,.02,0,.03,0,.01,0,.03,0,.04v27.86s-.02,6.77-.02,6.77v1.96s0,2.42,0,2.42Z"
        />
        <path
          class="cls-395"
          d="M628.79,281.28c0-.64,1.73-1.15,3.87-1.15s3.87,.52,3.87,1.15-1.73,1.15-3.87,1.15-3.87-.52-3.87-1.15Z"
        />
        <path
          class="cls-886"
          d="M632.66,280.72c1.13,0,2.14,.15,2.84,.38,.13,.04,.22,.17,.22,.31v1.17s0,24.7,0,24.7c0,1.11-.14,2.21-.41,3.28l-.66,2.63h-3.89l-.66-2.63c-.27-1.07-.41-2.17-.41-3.28v-25.87c0-.14,.08-.26,.21-.31,.69-.24,1.65-.37,2.76-.37Z"
        />
      </g>
      <rect
        class="cls-890"
        x="630.29"
        y="309.79"
        width="4.83"
        height="5.42"
        rx="1.23"
        ry="1.23"
        transform="translate(1265.4 625.01) rotate(180)"
      />
    </g>
    <g>
      <path
        class="cls-891"
        d="M655.35,277.04v70.42c0,1.27-.24,2.48-.65,3.55-.08,.22-.17,.43-.27,.64-.04,.07-.07,.15-.12,.22-1,1.95-2.66,3.31-4.59,3.55-.05,.01-.1,.02-.15,.02-.02,0-.04,0-.06,0-.17,.02-.34,.03-.5,.04h0c-.85,.05-1.71,.05-2.56,0-.16-.01-.32-.03-.48-.04-.04,0-.07,0-.1-.01-.05,0-.11-.01-.16-.02-1.88-.26-3.5-1.58-4.5-3.48-.04-.07-.09-.16-.12-.24-.1-.21-.19-.42-.28-.63-.43-1.09-.67-2.32-.67-3.62v-70.42c0-.31,.02-.62,.04-.92,.06-.65,.18-1.27,.35-1.86,.01-.05,.03-.1,.04-.15,.04-.14,.09-.29,.14-.43,.76-2.12,2.23-3.74,4.02-4.37,.04-.02,.09-.03,.13-.04,.16-.05,.33-.1,.5-.13,.2-.04,.41-.07,.61-.09,1.18-.1,2.36-.1,3.55,0,.19,.02,.38,.04,.56,.09,.17,.03,.34,.07,.5,.12,.04,.02,.09,.03,.13,.04,1.79,.61,3.26,2.22,4.03,4.32,.05,.14,.1,.29,.15,.43,.02,.05,.03,.1,.04,.15,.18,.6,.3,1.23,.36,1.88,.03,.32,.05,.63,.05,.96Z"
      />
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M649.07,347.6c2.36-3.19,6.06-4.54,6.21-4.6,.02,0,.04-.01,.07-.01v.65c-.51,.2-3.83,1.57-5.93,4.41-.09,.13-.25,.13-.35,.01-.1-.12-.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M649.07,347.6s-.05,.08-.06,.13c.01,.05,.03,.11,.06,.15,.1,.12,.25,.11,.35-.01,2.1-2.83,5.41-4.2,5.93-4.41v-.47s-.04,0-.07,.01c-.16,.06-3.85,1.42-6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M649.07,339.86c2.36-3.19,6.06-4.54,6.21-4.6,.02,0,.04-.01,.07-.01v.65c-.51,.2-3.83,1.57-5.93,4.41-.09,.13-.25,.13-.35,.01-.1-.12-.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M649.07,339.86s-.05,.08-.06,.13c.01,.05,.03,.11,.06,.15,.1,.12,.25,.11,.35-.01,2.1-2.83,5.41-4.2,5.93-4.41v-.47s-.04,0-.07,.01c-.16,.06-3.85,1.42-6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M649.07,332.13c2.36-3.19,6.06-4.54,6.21-4.6,.02,0,.04-.01,.07-.01v.65c-.51,.2-3.83,1.57-5.93,4.41-.09,.13-.25,.13-.35,.01-.1-.12-.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M649.07,332.13s-.05,.08-.06,.13c.01,.05,.03,.11,.06,.15,.1,.12,.25,.11,.35-.01,2.1-2.83,5.41-4.2,5.93-4.41v-.47s-.04,0-.07,.01c-.16,.06-3.85,1.42-6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M649.07,324.4c2.36-3.19,6.06-4.54,6.21-4.6,.02,0,.04-.01,.07-.01v.65c-.51,.2-3.83,1.57-5.93,4.41-.09,.13-.25,.13-.35,.01-.1-.12-.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M649.07,324.4s-.05,.08-.06,.13c.01,.05,.03,.11,.06,.15,.1,.12,.25,.11,.35-.01,2.1-2.83,5.41-4.2,5.93-4.41v-.47s-.04,0-.07,.01c-.16,.06-3.85,1.42-6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M649.07,316.66c2.36-3.19,6.06-4.54,6.21-4.6,.02,0,.04-.01,.07-.01v.65c-.51,.2-3.83,1.57-5.93,4.41-.09,.13-.25,.13-.35,.01-.1-.12-.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M649.07,316.66s-.05,.08-.06,.13c.01,.05,.03,.11,.06,.15,.1,.12,.25,.11,.35-.01,2.1-2.83,5.41-4.2,5.93-4.41v-.47s-.04,0-.07,.01c-.16,.06-3.85,1.42-6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M649.07,308.93c2.36-3.19,6.06-4.54,6.21-4.6,.02,0,.04-.01,.07-.01v.65c-.51,.2-3.83,1.57-5.93,4.41-.09,.13-.25,.13-.35,.01-.1-.12-.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M649.07,308.93s-.05,.08-.06,.13c.01,.05,.03,.11,.06,.15,.1,.12,.25,.11,.35-.01,2.1-2.83,5.41-4.2,5.93-4.41v-.47s-.04,0-.07,.01c-.16,.06-3.85,1.42-6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M649.07,301.2c2.36-3.19,6.06-4.54,6.21-4.6,.02,0,.04-.01,.07-.01v.65c-.51,.2-3.83,1.57-5.93,4.41-.09,.13-.25,.13-.35,.01-.1-.12-.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M649.07,301.2s-.05,.08-.06,.13c.01,.05,.03,.11,.06,.15,.1,.12,.25,.11,.35-.01,2.1-2.83,5.41-4.2,5.93-4.41v-.47s-.04,0-.07,.01c-.16,.06-3.85,1.42-6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M649.07,293.47c2.36-3.19,6.06-4.54,6.21-4.6,.02,0,.04-.01,.07-.01v.65c-.51,.2-3.83,1.57-5.93,4.41-.09,.13-.25,.13-.35,.01-.1-.12-.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M649.07,293.47s-.05,.08-.06,.13c.01,.05,.03,.11,.06,.15,.1,.12,.25,.11,.35-.01,2.1-2.83,5.41-4.2,5.93-4.41v-.47s-.04,0-.07,.01c-.16,.06-3.85,1.42-6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M649.07,285.73c2.36-3.19,6.06-4.54,6.21-4.6,.02,0,.04-.01,.07-.01v.65c-.51,.2-3.83,1.57-5.93,4.41-.09,.13-.25,.13-.35,.01-.1-.12-.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M649.07,285.73s-.05,.08-.06,.13c.01,.05,.03,.11,.06,.15,.1,.12,.25,.11,.35-.01,2.1-2.83,5.41-4.2,5.93-4.41v-.47s-.04,0-.07,.01c-.16,.06-3.85,1.42-6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M654.95,274.2c-.65,.29-1.89,.9-3.17,1.88-.82,.63-1.65,1.41-2.35,2.35-.1,.12-.25,.13-.35,.01-.07-.09-.09-.21-.06-.32,0-.02,.01-.04,.02-.07,.01-.02,.02-.04,.04-.06,.55-.73,1.16-1.37,1.79-1.92,1.51-1.33,3.09-2.11,3.9-2.47,.05,.14,.1,.29,.15,.43,.02,.05,.03,.1,.04,.15Z"
          />
        </g>
        <path
          class="cls-566"
          d="M654.9,274.05c-.7,.32-2.02,.98-3.34,2.03-.75,.6-1.5,1.32-2.13,2.18-.1,.13-.25,.13-.35,.01-.03-.04-.05-.1-.06-.15,0-.02,.01-.04,.02-.07,.01-.02,.02-.04,.04-.06,.55-.73,1.16-1.37,1.79-1.92,1.51-1.33,3.09-2.11,3.9-2.47,.05,.14,.1,.29,.15,.43Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M646.42,347.64c-2.36-3.19-6.06-4.54-6.21-4.6-.02,0-.04-.01-.07-.01v.65c.51,.2,3.83,1.57,5.93,4.41,.09,.13,.25,.13,.35,.01,.1-.12,.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M646.42,347.64s.05,.08,.06,.13c-.01,.05-.03,.11-.06,.15-.1,.12-.25,.11-.35-.01-2.1-2.83-5.41-4.2-5.93-4.41v-.47s.04,0,.07,.01c.16,.06,3.85,1.42,6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M646.42,339.91c-2.36-3.19-6.06-4.54-6.21-4.6-.02,0-.04-.01-.07-.01v.65c.51,.2,3.83,1.57,5.93,4.41,.09,.13,.25,.13,.35,.01,.1-.12,.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M646.42,339.91s.05,.08,.06,.13c-.01,.05-.03,.11-.06,.15-.1,.12-.25,.11-.35-.01-2.1-2.83-5.41-4.2-5.93-4.41v-.47s.04,0,.07,.01c.16,.06,3.85,1.42,6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M654.7,351.02c-.08,.22-.17,.43-.27,.63-.04,.08-.07,.15-.11,.22-1.19,.6-3.12,1.75-4.59,3.55-.05,0-.1,.02-.15,.02-.02,0-.04,0-.06,0-.17,.02-.33,.03-.5,.04,0,0,0,.01,0,.02,0,0,0-.01,0-.02,0-.02,0-.03,.02-.05,0-.02,.02-.04,.03-.06,1.84-2.47,4.47-3.84,5.63-4.36Z"
          />
        </g>
        <path
          class="cls-566"
          d="M654.7,351.02c-.08,.22-.17,.43-.27,.63-1.22,.6-3.32,1.83-4.85,3.79-.02,0-.04,0-.06,0-.17,.02-.33,.03-.5,.04,0-.02,0-.03,.02-.05,0-.02,.02-.04,.03-.06,1.84-2.47,4.47-3.84,5.63-4.36Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M646.42,355.43s.02,.04,.03,.06c-.16-.01-.32-.03-.48-.04-.03,0-.07,0-.1-.01-.05,0-.1,0-.16-.02-1.45-1.75-3.32-2.88-4.5-3.47h0c-.04-.08-.08-.16-.12-.24-.1-.21-.19-.41-.28-.63,1.17,.52,3.79,1.89,5.61,4.35Z"
          />
        </g>
        <path
          class="cls-566"
          d="M646.45,355.49c-.16-.01-.32-.03-.48-.04-.03,0-.07,0-.1-.01-1.52-1.92-3.57-3.13-4.78-3.73-.1-.21-.19-.41-.28-.63,1.17,.52,3.79,1.89,5.61,4.35,.01,.02,.02,.04,.03,.06Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M646.42,332.18c-2.36-3.19-6.06-4.54-6.21-4.6-.02,0-.04-.01-.07-.01v.65c.51,.2,3.83,1.57,5.93,4.41,.09,.13,.25,.13,.35,.01,.1-.12,.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M646.42,332.18s.05,.08,.06,.13c-.01,.05-.03,.11-.06,.15-.1,.12-.25,.11-.35-.01-2.1-2.83-5.41-4.2-5.93-4.41v-.47s.04,0,.07,.01c.16,.06,3.85,1.42,6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M646.42,324.45c-2.36-3.19-6.06-4.54-6.21-4.6-.02,0-.04-.01-.07-.01v.65c.51,.2,3.83,1.57,5.93,4.41,.09,.13,.25,.13,.35,.01,.1-.12,.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M646.42,324.45s.05,.08,.06,.13c-.01,.05-.03,.11-.06,.15-.1,.12-.25,.11-.35-.01-2.1-2.83-5.41-4.2-5.93-4.41v-.47s.04,0,.07,.01c.16,.06,3.85,1.42,6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M646.42,316.71c-2.36-3.19-6.06-4.54-6.21-4.6-.02,0-.04-.01-.07-.01v.65c.51,.2,3.83,1.57,5.93,4.41,.09,.13,.25,.13,.35,.01,.1-.12,.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M646.42,316.71s.05,.08,.06,.13c-.01,.05-.03,.11-.06,.15-.1,.12-.25,.11-.35-.01-2.1-2.83-5.41-4.2-5.93-4.41v-.47s.04,0,.07,.01c.16,.06,3.85,1.42,6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M646.42,308.98c-2.36-3.19-6.06-4.54-6.21-4.6-.02,0-.04-.01-.07-.01v.65c.51,.2,3.83,1.57,5.93,4.41,.09,.13,.25,.13,.35,.01,.1-.12,.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M646.42,308.98s.05,.08,.06,.13c-.01,.05-.03,.11-.06,.15-.1,.12-.25,.11-.35-.01-2.1-2.83-5.41-4.2-5.93-4.41v-.47s.04,0,.07,.01c.16,.06,3.85,1.42,6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M646.42,301.25c-2.36-3.19-6.06-4.54-6.21-4.6-.02,0-.04-.01-.07-.01v.65c.51,.2,3.83,1.57,5.93,4.41,.09,.13,.25,.13,.35,.01,.1-.12,.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M646.42,301.25s.05,.08,.06,.13c-.01,.05-.03,.11-.06,.15-.1,.12-.25,.11-.35-.01-2.1-2.83-5.41-4.2-5.93-4.41v-.47s.04,0,.07,.01c.16,.06,3.85,1.42,6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M646.42,293.51c-2.36-3.19-6.06-4.54-6.21-4.6-.02,0-.04-.01-.07-.01v.65c.51,.2,3.83,1.57,5.93,4.41,.09,.13,.25,.13,.35,.01,.1-.12,.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M646.42,293.51s.05,.08,.06,.13c-.01,.05-.03,.11-.06,.15-.1,.12-.25,.11-.35-.01-2.1-2.83-5.41-4.2-5.93-4.41v-.47s.04,0,.07,.01c.16,.06,3.85,1.42,6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M646.42,285.78c-2.36-3.19-6.06-4.54-6.21-4.6-.02,0-.04-.01-.07-.01v.65c.51,.2,3.83,1.57,5.93,4.41,.09,.13,.25,.13,.35,.01,.1-.12,.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M646.42,285.78s.05,.08,.06,.13c-.01,.05-.03,.11-.06,.15-.1,.12-.25,.11-.35-.01-2.1-2.83-5.41-4.2-5.93-4.41v-.47s.04,0,.07,.01c.16,.06,3.85,1.42,6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M646.41,278.52c-.1,.12-.25,.11-.35-.02-.73-.98-1.6-1.78-2.45-2.42-1.25-.95-2.46-1.54-3.09-1.82,.01-.05,.03-.1,.04-.15,.04-.14,.09-.29,.14-.43,.78,.34,2.33,1.11,3.84,2.4,.65,.56,1.3,1.23,1.87,1.99,.02,.02,.03,.04,.04,.06,.01,.02,.02,.04,.02,.07,.03,.11,0,.24-.06,.32Z"
          />
        </g>
        <path
          class="cls-566"
          d="M646.48,278.2c-.01,.05-.03,.11-.06,.15-.1,.12-.25,.11-.35-.02-.66-.89-1.44-1.64-2.23-2.25-1.3-1.02-2.58-1.66-3.27-1.97,.04-.14,.09-.29,.14-.43,.78,.34,2.33,1.11,3.84,2.4,.65,.56,1.3,1.23,1.87,1.99,.02,.02,.03,.04,.04,.06,.01,.02,.02,.04,.02,.07Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M650.72,269.3c-.45,.43-.9,.92-1.29,1.46-.1,.13-.25,.13-.35,.01-.07-.09-.09-.21-.06-.32,0-.02,.01-.04,.02-.07,.01-.02,.02-.04,.04-.06,.32-.43,.66-.82,1.01-1.18,.17,.03,.34,.07,.5,.12,.04,.02,.09,.03,.13,.04Z"
          />
        </g>
        <path
          class="cls-566"
          d="M650.59,269.26c-.41,.4-.8,.84-1.16,1.33-.1,.13-.25,.13-.35,.01-.03-.04-.05-.09-.06-.15,0-.02,.01-.04,.02-.07,.01-.02,.02-.04,.04-.06,.32-.43,.66-.82,1.01-1.18,.17,.03,.34,.07,.5,.12Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M646.41,270.81c-.1,.12-.25,.11-.35-.01-.41-.55-.86-1.05-1.33-1.49,.04-.02,.09-.03,.13-.04,.16-.05,.33-.1,.5-.13,.37,.37,.73,.78,1.05,1.23,.02,.02,.03,.04,.04,.06,.01,.02,.02,.05,.02,.07,.03,.11,0,.24-.06,.32Z"
          />
        </g>
        <path
          class="cls-566"
          d="M646.48,270.49c-.01,.05-.03,.11-.06,.15-.1,.12-.25,.11-.35-.01-.37-.5-.78-.95-1.2-1.36,.16-.05,.33-.1,.5-.13,.37,.37,.73,.78,1.05,1.23,.02,.02,.03,.04,.04,.06,.01,.02,.02,.05,.02,.07Z"
        />
      </g>
    </g>
    <path
      class="cls-533"
      d="M639.52,271.15v5.14c-.75,.28-1.36,.85-1.7,1.58v-5.32c.14-.49,.34-.96,.58-1.4h1.12Z"
    />
    <path
      class="cls-533"
      d="M654.95,274.2c.18,.6,.3,1.23,.36,1.88h-14.68c-.15,0-.3,.01-.44,.04,.06-.65,.18-1.27,.35-1.86,.01-.05,.03-.1,.04-.15,.04-.14,.09-.29,.14-.43,.76-2.12,2.23-3.74,4.02-4.37,.04-.02,.09-.03,.13-.04,.16-.05,.33-.1,.5-.13,.2-.04,.41-.07,.61-.09,1.18-.1,2.36-.1,3.55,0,.19,.02,.38,.04,.56,.09,.17,.03,.34,.07,.5,.12,.04,.02,.09,.03,.13,.04,1.79,.61,3.26,2.22,4.03,4.32,.05,.14,.1,.29,.15,.43,.02,.05,.03,.1,.04,.15Z"
    />
    <path
      class="cls-533"
      d="M657.68,271.15v5.08c-.29-.1-.61-.14-.94-.14h-.77v-4.93h1.7Z"
    />
    <path
      class="cls-201"
      d="M658.92,269.72v4.49h-.93c0-1.19-1-2.15-2.19-2.15h-16.12c-1.19,0-2.19,.96-2.19,2.15h-.93s0-4.49,0-4.49c0-4.17,3.39-7.56,7.57-7.56h7.22c4.18,0,7.57,3.39,7.57,7.56Z"
    />
    <path
      class="cls-45"
      d="M651.36,262.16h-7.23c-4.18,0-7.56,3.39-7.56,7.56v4.49c0-1.72,1.4-3.11,3.12-3.11h16.12c1.72,0,3.11,1.39,3.11,3.11v-2.26s0-2.23,0-2.23c0-4.18-3.39-7.56-7.56-7.56Z"
    />
  </g>
</template>

<script>
export default {
  props: {
    severityClass: String
  },
  methods: {
    changeSeverity(section) {
      this.$emit('changeSeverity', section);
    }
  }
};
</script>
